import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../core/security/auth.service';
import {Router} from '@angular/router';
import {Message} from 'primeng/components/common/api';
import {MessageSeverity} from '../../core/commons/message-severity';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    providers: [AuthService]
})
export class LoginComponent implements OnInit {

     username = '';
     password = '';
     mensajes: Message[] = [];
     loginForm: FormGroup;

    constructor(private authService: AuthService, private router: Router, private fb: FormBuilder) {
        this.loginForm = fb.group({
            'username': ['', Validators.required],
            'password': ['', Validators.required]
        });
    }

    ngOnInit() {
        if (this.authService.isLoggedIn())
            this.router.navigate(['home']);

    }

    public login(event) {
        this.authService.login(this.loginForm.get('username').value, this.loginForm.get('password').value)
            .subscribe(
                success => {
                    console.log('logeado;');
                    this.router.navigate(['home']);
                },
                err => {
                    this.pushMsg(MessageSeverity.ERROR, 'Intento de ingreso fallido', 'Usuario o contraseña incorrecta.');
                });
    }

    public pushMsg(severity: string, summary: string, detail: string) {
        this.mensajes = [];
        this.mensajes.push({severity: severity, summary: summary, detail: detail});
    }

    public goToRegister() {
        this.router.navigate(["register"]);
    }

}



// WEBPACK FOOTER //
// ./src/app/login/component/login.component.ts